import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useCallback, useState } from "react";

export default function SelectWithCheckboxes({
  options,
  label,
  multiple = true,
  defaultValue = [],
  width = 200,
  size = "medium",
  onChangeHandler = () => {},
}) {
  const [selectedOptions, setSelectedOptions] = useState(defaultValue || []);

  // Toggle Select All and Deselect All
  const onSelectAll = useCallback(
    (event) => {
      if (event.target.checked) {
        // Select all options
        setSelectedOptions(options);
      } else {
        // Deselect all options
        setSelectedOptions([]);
      }
      onChangeHandler(event.target.checked ? options : []);
    },
    [options, onChangeHandler],
  );

  // Handle changes when individual items are selected/deselected
  const handleOptionChange = (event, newSelectedOptions) => {
    setSelectedOptions(newSelectedOptions);
    onChangeHandler(newSelectedOptions);
  };

  return (
    <>
      <div className="select-all-checkbox">
        {multiple && (
          <label>
            <input
              type="checkbox"
              onChange={onSelectAll}
              checked={
                selectedOptions.length === options.length && options.length > 0
              }
            />
            Select all
          </label>
        )}
      </div>
      <Autocomplete
        onChange={handleOptionChange}
        className="autocomplete-with-checkboxes"
        multiple={multiple}
        size={size}
        options={options}
        value={selectedOptions}
        disableCloseOnSelect
        disablePortal
        getOptionLabel={(option) => option.title}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            <span className="autocomplete-option">{option.title}</span>
          </li>
        )}
        style={{ width: width }}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </>
  );
}
